import { lockScroll } from '../modules/lockScroll.js';

var search = {},
		DOM = {},
		prop = {
			active: false,
			busy: false
		};

function inputWidth() {
	let inputWidth = $('#sitewide #top-side-menu .buttons').width() - parseInt(DOM.$form.css('right'));
	if (Modernizr.mq('(max-width: 767px)')) {
		inputWidth = $(window).width() - 96;
	} else if (Modernizr.mq('(min-width: 1024px)') && Modernizr.mq('(max-width: 1279px)')) {
		inputWidth = $('#sitewide #top-side-menu .buttons').width() - 52;
	}
	DOM.$input.css({'width' : inputWidth});
}

function open() {
	if (prop.busy == false) {
		prop.busy = true;
		prop.active = true;
		inputWidth();
		let offset = $(window).scrollTop(),
				mobFix = (offset <= 64 && Modernizr.mq('(max-width: 767px)')) ? true : false;
		if (mobFix) {
			DOM.$sitewide.css({'position' : 'absolute'});
			DOM.$sideMenu.css({'transform' : 'translateY(-'+(64-offset)+'px)'});
		}
		DOM.$this.addClass('is-active');
		DOM.$overlay.addClass('is-active');
		DOM.$sitewide.addClass('animate-menu');
		setTimeout(function() {
			DOM.$sitewide.addClass('has-open-search');
			DOM.$close.addClass('is-active-for-search');
			DOM.$form.addClass('has-gray-bg').addClass('is-active');
			DOM.$this.addClass('animate');
			DOM.$this.addClass('animate-elements');
			DOM.$overlay.addClass('animate');
			setTimeout(function() {
				if (mobFix) {
					DOM.$sitewide.removeClass('animate-menu');
					DOM.$sitewide.removeAttr('style');
					DOM.$sideMenu.removeAttr('style');
				}
				lockScroll.init(true);
				DOM.$form.find('.input').focus();
				prop.busy = false;
			}, 500);
		}, 100);
	}
}

function close() {
	if (prop.busy == false) {
		prop.busy = true;
		prop.active = false;
		lockScroll.init(false);
		let offset = $(window).scrollTop(),
				mobFix = (offset <= 64 && Modernizr.mq('(max-width: 767px)')) ? true : false;
		if (mobFix) {
			DOM.$sitewide.css({'position' : 'absolute'});
			DOM.$sideMenu.css({'transform' : 'translateY(-'+(64-offset)+'px)'});
		}
		setTimeout(function() {
			if (mobFix) {
				DOM.$sideMenu.css({'transform' : 'translateY(0px)'});
			}
			DOM.$sitewide.addClass('animate-menu');
			DOM.$sitewide.removeClass('has-open-search');
			DOM.$form.removeClass('is-active');
			DOM.$this.removeClass('animate').removeClass('animate-desktop');
			DOM.$overlay.removeClass('animate');
			DOM.$close.removeClass('is-active-for-search');
			setTimeout(function() {
				if (mobFix) {
					DOM.$sitewide.removeAttr('style');
					DOM.$sideMenu.removeAttr('style');
				}
				DOM.$sitewide.removeClass('animate-menu');
				DOM.$form.removeClass('has-gray-bg');
				DOM.$this.removeClass('is-active').removeClass('is-active-desktop');
				DOM.$this.removeClass('animate-elements').removeClass('animate-elements-desktop');
				DOM.$overlay.removeClass('is-active');
				prop.busy = false;
			}, 500);
		}, 100);
	}
}

search.init = function() {
	DOM = {
		$btn: $('form.search-bar .el-fake-submit'),
		$close: $('.js-toggle-menu'),
		$form: $('form.search-bar'),
		$input: $('form.search-bar .input'),
		$this: $('#search-faq'),
		$overlay: $('#search-faq-overlay'),
		$sitewide: $('#sitewide, #sitewide-beam'),
		$sideMenu: $('#sitewide #top-side-menu'),
		$archive: $('body.post-type-archive'),
		$accordion: $('#content .accordion')
	}
	if (DOM.$this.hasClass('is-active-desktop')) {
		prop.active = true;
		inputWidth();
	}
	DOM.$btn.click(function (e) {
		if (prop.active == false) {
			e.preventDefault();
			open();
		} else {
			DOM.$form.submit();
		}
	});
	$(document).click(function(e) {
		if (prop.active == true) {
			console.log($(e.target).closest("#search-faq").length);
			console.log($(e.target).closest("#top-side-menu").length);
			if ($(e.target).closest("#search-faq").length <= 0 && $(e.target).closest("#top-side-menu").length <= 0) {
				close();
			}
		}
	});
	DOM.$close.click(function(e) {
		e.preventDefault();
		if (prop.active == true || DOM.$this.hasClass('is-active-desktop')) {
			close();
		}
	});
	// handle active faq accordions on post type archive
	if ( DOM.$archive.length > 0 && window.location.hash ) {
		if ( DOM.$archive.is( '.post-type-archive-' + customData.post_types.faq ) ) {
			// is FAQ archive
			var $hash = window.location.hash;
			$hash = $hash.substring( 1, ( $hash.length ) );
			var $item = DOM.$accordion.find('a[name="' + $hash + '"]');
			if ( $item.length > 0 ) {
				$item.closest('.accordion-header').trigger('click');
				location.hash = "#" + $hash;
			}
			DOM.$this.find('.faq a[href*="#' + $hash + '"]').click(function(e){
				e.preventDefault();
				$item.closest('.accordion-header').trigger('click');
				
			});
		}
	}
}

search.resize = function() {
	if (prop.active == true || DOM.$this.hasClass('is-active-desktop')) {
		inputWidth();
	}
}

export { search };
